export const openApp = (token, appName, appUrl, External, navigate) => {
  console.log("opemAPpp", appName, appUrl);
  if (!token) {
    navigate("/");
  }

  // if (appName === "GSPT") {
  //   // NOTE : Please do not change this url as it will required for AGhub
  //   window.open(
  //     `${appUrl}?token=${token?.accessToken?.accessToken}&isUserFromAgHub=true`,
  //     "_blank"
  //   );
  // } else {
  //   window.open(`${appUrl}?external=${!External}`, "_blank");
  // }

   window.open(`${appUrl}?external=${!External}`, "_blank");
};
